import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useStudentPayments(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'payments'],
        queryFn: () => apiClient(`/students/${studentId}/payments`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
// ── Anotaciones privadas del director ────────────────────────────────────────
export function useStudentNotes(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'notes'],
        queryFn: () => apiClient(`/students/${studentId}/notes`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useAddStudentNote(studentId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (note) => apiClient(`/students/${studentId}/notes`, {
            method: 'POST',
            body: JSON.stringify({ note }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['students', studentId, 'notes'] }),
    });
}
export function useDeleteStudentNote(studentId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (noteId) => apiClient(`/students/${studentId}/notes/${noteId}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['students', studentId, 'notes'] }),
    });
}
export function useStudentAttendance(studentId, range, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'attendance', range?.from, range?.to],
        queryFn: () => {
            const params = new URLSearchParams();
            if (range?.from)
                params.set('from', range.from);
            if (range?.to)
                params.set('to', range.to);
            const qs = params.toString();
            return apiClient(`/students/${studentId}/attendance${qs ? `?${qs}` : ''}`);
        },
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useStudentRequests(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'requests'],
        queryFn: () => apiClient(`/students/${studentId}/requests`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useStudentNotifications(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'notifications'],
        queryFn: () => apiClient(`/students/${studentId}/notifications`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useStudentMaterialPermissions(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'material-permissions'],
        queryFn: () => apiClient(`/students/${studentId}/material-permissions`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useRevokeStudentMaterialAccess(studentId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (materialId) => apiClient(`/materials/${materialId}/permissions/${studentId}`, { method: 'DELETE' }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['students', studentId, 'material-permissions'] });
        },
    });
}
export function useStudentShiftChanges(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'shift-changes'],
        queryFn: () => apiClient(`/students/${studentId}/shift-changes`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useStudentAuditLog(studentId, enabled = true) {
    return useQuery({
        queryKey: ['students', studentId, 'audit-log'],
        queryFn: () => apiClient(`/students/${studentId}/audit-log`),
        enabled: !!studentId && enabled,
        staleTime: 1000 * 60,
    });
}
//# sourceMappingURL=useStudentTabs.js.map